<template>
  <div class="email-box">
    <label>Email/SMS Test</label>
    <input v-model="d2dId" placeholder="Enter D2D ID#" />
    <div class="op-btn btn-md btn-block btn-success" @click="submit">
      SEND EMAIL
    </div>
    <div class="op-btn btn-md btn-block btn-primary" @click="submitSMS">
      SEND SMS
    </div>
  </div>
</template>

<script>
/* global CONFIG */
export default {
  name: 'service-selection',
  data () {
    return {
      d2dId: ''
    }
  },
  computed: {
  },
  methods: {
    submit () {
      let self = this
      self.$store.commit('global/setLoaderData', {show: true})
      self.$sdk.post2(`${CONFIG.d2dGateway}/d2d/email`, {
        token: self.$store.state.user.token,
        d2dId: self.d2dId,
        send: true
      }, r => {
        self.$store.commit('global/setLoaderData', {show: false})
        if (r.error) {
          self.$store.commit('global/setAlertData', {
            show: true,
            message: r.error.message
          })
          return
        }
        self.$store.commit('global/setAlertData', {
          show: true,
          message: 'Email sent!'
        })
      })
    },
    submitSMS () {
      let self = this
      self.$store.commit('global/setLoaderData', {show: true})
      self.$sdk.post2(`${CONFIG.d2dGateway}/d2d/sms`, {
        token: self.$store.state.user.token,
        d2dId: self.d2dId,
        send: true
      }, r => {
        self.$store.commit('global/setLoaderData', {show: false})
        if (r.error) {
          self.$store.commit('global/setAlertData', {
            show: true,
            message: r.error.message
          })
          return
        }
        self.$store.commit('global/setAlertData', {
          show: true,
          message: 'SMS Sent!'
        })
      })
    }
  },
  mounted () {
  }
}
</script>

<style lang="scss" scoped>
.email-box{
  border: 1px solid #ccc;
  padding: 40px 20px;
  background: #fafafa;
  max-width: 500px;
  margin: 0 auto;
  border-radius: 4px;

  label{
    font-size: 21px;
    font-weight: 600;
    display: block;
    text-align: center;
    margin-bottom: 30px;
  }
  input{
    width: 100%;
    padding: 10px 15px;
    line-height: 1;
    outline: none;
    border: 1px solid #aaa;
    margin-bottom: 10px;
  }
}

.btn-md{
  margin-bottom: 15px;
}
</style>



// WEBPACK FOOTER //
// EmailTest.vue?55e360c2